<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";
import type {Delivery} from "#magnolia-layer/types/api";
import type {Page} from "~/types/mgnl";
import usePageQueryRef from "~/composables/usePageQueryRef";
import {useOffsetPagination} from "@vueuse/core";
import {useMagnoliaFetch} from "#magnolia-layer/composables/use-magnolia-fetch";

const props = defineProps<{
  metadata: Area;
  author: string;
}>();

const pageRef = usePageQueryRef();
const limit = ref(8);
const offset = computed(() => (pageRef.value - 1) * limit.value);
const total = computed(() => content.value?.total ?? 0);
const runtimeConfig = useRuntimeConfig();

watch(pageRef, () => {
  if (import.meta.server) return;
  window.scrollTo(0, 0);
});

const params = computed<Record<string, string | number>>(() => ({
  "@authors": props.author,
  offset: offset.value,
  limit: limit.value,
}));

const {data: content, error} = await useMagnoliaFetch<Delivery<Page>>(
  runtimeConfig.public.mgnl.apiPageOverview,
  {params},
);

const offsetPagination = useOffsetPagination({
  page: pageRef,
  total,
  pageSize: limit.value,
});
usePaginationHeadLinks(offsetPagination);
useErrorStatusForwarding(error);
</script>

<template>
  <Breadcrumb></Breadcrumb>
  <ArticleGrid :content :offsetPagination :error></ArticleGrid>
</template>

<style lang="scss" scoped>
* {
  overflow-anchor: none;
}
</style>
